import { formatJalaliDateFromDate } from '@/modules/Core/utils/time'

const ONE_DAY_MS = 24 * 60 * 60 * 1000

const relativeTimeFormatter = new Intl.RelativeTimeFormat('fa', {
  numeric: 'auto',
})

function getRelativeTimeLabel(diffMs: number): string {
  const absDiffMs = Math.abs(diffMs)
  const minuteMs = 60 * 1000
  const hourMs = 60 * minuteMs

  if (absDiffMs < hourMs) {
    const minutes = Math.max(1, Math.round(absDiffMs / minuteMs))
    return relativeTimeFormatter.format(-minutes, 'minute')
  }

  const hours = Math.max(1, Math.round(absDiffMs / hourMs))
  return relativeTimeFormatter.format(-hours, 'hour')
}

export function formatNotificationTime(createdAt: string): string {
  if (!createdAt?.trim()) {
    return ''
  }

  const createdDate = new Date(createdAt)
  const timestamp = createdDate.getTime()

  if (Number.isNaN(timestamp)) {
    return ''
  }

  const diffMs = timestamp - Date.now()

  if (Math.abs(diffMs) < ONE_DAY_MS) {
    return getRelativeTimeLabel(diffMs)
  }

  return formatJalaliDateFromDate(createdDate)
}
